module.exports = __webpack_public_path__ + "static/media/filter-sources2.a2b2c1ca.png";